export enum Message {
  AppointmentScheduled = 'appointment-scheduled',
  CancelScheduling = 'cancel-scheduling',
  FinishedScheduling = 'finished-scheduling',
};
